const ArrowWithCircleIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.6875 9.3125L23.6875 15.3125C23.875 15.5 24 15.75 24 16C24 16.3125 23.875 16.5625 23.6875 16.75L17.6875 22.75C17.3125 23.125 16.625 23.125 16.25 22.75C15.875 22.375 15.875 21.6875 16.25 21.3125L20.5625 17H9C8.4375 17 8 16.5625 8 16C8 15.5 8.4375 15 9 15H20.5625L16.25 10.75C15.875 10.375 15.875 9.6875 16.25 9.3125C16.625 8.9375 17.3125 8.9375 17.6875 9.3125ZM16 0C24.8125 0 32 7.1875 32 16C32 24.875 24.8125 32 16 32C7.125 32 0 24.875 0 16C0 7.1875 7.125 0 16 0ZM16 30C23.6875 30 30 23.75 30 16C30 8.3125 23.6875 2 16 2C8.25 2 2 8.3125 2 16C2 23.75 8.25 30 16 30Z" fill="#33343B"/>
    </svg>
  );
};

export default ArrowWithCircleIcon;
